module.exports = function() {
  return new Worker(__webpack_public_path__ + "18449259ef83202260b7.worker.js");
};